import {
    CardSlider,
    CardSliderItem,
    CardSliderItemRow,
} from "@hatch-digital-nl/bravilor-storybook";
import { JSX } from "react";
import { useNavigate } from "react-router-dom";
import { ProductOlderModelAssociationInterface } from "../../interfaces/apiV2/product/ProductAssociatedInterface";
import { RouteEnum } from "../../enums/RouteEnum";
import { useStringTranslation } from "../../hooks/useStringTranslation";

interface Props {
    items: ProductOlderModelAssociationInterface[];
    title: string;
}

const buildOlderModelRows = (
    item: ProductOlderModelAssociationInterface,
    artNumberText: string,
): CardSliderItemRow[] => {
    const rows: CardSliderItemRow[] = [
        { label: artNumberText, value: item.identifier },
    ];

    if (item.expirationYear?.label && item.expirationYear?.value) {
        rows.push({
            label: item.expirationYear.label,
            value: item.expirationYear.value,
        });
    }

    return rows;
};

export const ProductOlderModels = (props: Props): JSX.Element | null => {
    const navigate = useNavigate();
    const { t, translations } = useStringTranslation();

    const visibleItems = props.items.filter((item) => item.label || item.image);

    if (visibleItems.length === 0) {
        return null;
    }

    const artNumberText = translations ? t("art-nr") : "Art. Nr.";

    const viewProductText = translations ? t("view-product") : "View Product";

    const totalLabel = translations ? t("total") : "total";

    return (
        <CardSlider
            title={props.title}
            totalCount={visibleItems.length}
            totalLabel={totalLabel}
            slidesPerView={6}
            className="c-card-slider--full-width"
        >
            {visibleItems.map((item) => (
                <CardSliderItem
                    key={item.id}
                    title={item.label}
                    image={item.image ?? ""}
                    rows={buildOlderModelRows(item, artNumberText)}
                    buttonText={viewProductText}
                    onButtonClick={() =>
                        navigate(`${RouteEnum.PRODUCT_RANGE}/${item.id}`)
                    }
                />
            ))}
        </CardSlider>
    );
};
